// Dosya: src/pages/MatchPage.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MatchHeader from "./MatchHeader";
import MatchTimeline from "./MatchTimeline";
import MatchTabs from "./MatchTabs";
import { useData } from "./Cache";
import "./style.css";

const calculateMatchResults = (allMatches, firstTeam, secondTeam) => {
  const related = allMatches.filter(
    (m) =>
      (m.first_team_name === firstTeam && m.second_team_name === secondTeam) ||
      (m.first_team_name === secondTeam && m.second_team_name === firstTeam)
  );

  let firstWins = 0,
    secondWins = 0,
    draws = 0;

  related.forEach((m) => {
    if (m.first_team_score > m.second_team_score) {
      m.first_team_name === firstTeam ? firstWins++ : secondWins++;
    } else if (m.first_team_score < m.second_team_score) {
      m.second_team_name === firstTeam ? firstWins++ : secondWins++;
    } else {
      draws++;
    }
  });

  return { firstTeam, secondTeam, firstWins, secondWins, draws };
};

const MatchPage = () => {
  const { matchID, leagueName, cityName } = useParams();
  const { matches, players, playerStatistics1, loading, teams, error } = useData();

  const [match, setMatch] = useState(null);
  const [playerStats, setPlayerStats] = useState([]);
  const [matchResults, setMatchResults] = useState(null);

  useEffect(() => {
    const foundMatch = matches.find((m) => m.id === Number(matchID));
    if (!foundMatch) return;

    const firstTeam = teams.find((t) => t.team_name === foundMatch.first_team_name);
    const secondTeam = teams.find((t) => t.team_name === foundMatch.second_team_name);

    setMatch({
      ...foundMatch,
      first_team_logo: firstTeam?.logo,
      second_team_logo: secondTeam?.logo,
      first_team_id: firstTeam?.id,
      second_team_id: secondTeam?.id,
    });
  }, [matchID, matches, teams]);

  useEffect(() => {
    if (!match) return;

    const stats = playerStatistics1
      .filter((s) => s.match_id === match.id)
      .map((s) => {
        const player = players.find((p) => p.id === s.player_id) || {};
        const team = teams.find((t) => t.id === s.team_id) || {};
        return { ...s, player, team };
      });

    setPlayerStats(stats);
    setMatchResults(calculateMatchResults(matches, match.first_team_name, match.second_team_name));
  }, [match, matches, players, playerStatistics1, teams]);

  if (loading) return <p className="loading">Yükleniyor...</p>;
  if (error) return <p className="error">Hata: {error}</p>;
  if (!match) return <p>Maç bulunamadı.</p>;

  return (
    <div>
      <Header />
      <main className="match-container">
        <MatchHeader match={match} />

        <section className="timeline-section">
          <h2 className="section-title">⏱ Maç Zaman Çizelgesi</h2>
          <MatchTimeline match={match} playerStats={playerStats} />
        </section>

        <MatchTabs
          match={match}
          playerStats={playerStats}
          matchResults={matchResults}
          cityName={cityName}
          leagueName={leagueName}
        />
      </main>
      <Footer />
    </div>
  );
};

export default MatchPage;
